<template>
	<el-drawer title="开闭线管理" :visible.sync="dialogVisible"  size="60%" :modal-append-to-body="false" direction="rtl" :wrapperClosable="false"
	 class="customer-drawer-common add-edit-effect">
		<section>
			<div v-for="(item,index) in data" :key="index" class="add-edit-effect__content">
				<h1>{{item.name}}</h1>
				<addEditItem :column="item" :data="getTableData(item.type)" @updateData="updateData"></addEditItem>
			</div>
			<div class="add-edit-effect__desc">
				<span>*  注意</span>
				<ol>
					<li>1. 同类时间设置为 并集关系</li>
					<li>2. 不同类时间优先级为：特殊上班时间＞闭线时间＞开线时间。根据客人进线时间，系统会按优先级顺序判断进线时间属于何种时间</li>
				</ol>
			</div>
		</section>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '保 存' }}
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import addEditItem from './addEditItem.vue'
	export default {
		components: {
			addEditItem
		},
		props: ['details'],
		watch: {
			'details': {
				handler(val) {
					this.getDetail(val)
				},
				deep: true
			}
		},
		data() {
			return {
				dialogVisible: false,
				post_datas: {
					exceptionList: [],
					holidayList: [],
					workDayList: []
				},
				data: [{
						name: '开线（上班）时间设置',
						type: 'workDayList',
						tableData: [],
						add_obj: {
							priority: '',
							time: '',
							workdaySubType: '',
						},
						column: [
							// {
							// 	label: "优先级",
							// 	prop: "index",
							// 	type: "index",
							// 	width: 80
							// },
							{
								label: '日期',
								prop: 'workdaySubType',
								slotScope: true,
							},
							{
								label: '工作时间',
								prop: 'time',
								slotScope: true,
								width: 300,
							},
							{
								label: '操作',
								prop: 'action',
								slotScope: true,
								width: 200,
							}
						]
					},
					{
						name: '闭线（节假日）时间设置',
						type: 'holidayList',
						tableData: [],
						add_obj: {
							date: [],
							priority: '',
							// time: '',
							msgId: '',
							remark: ''
						},
						column: [
							// {
							// 	label: "优先级",
							// 	prop: "index",
							// 	type: "index",
							// 	width: 80
							// }, 
							{
								label: '日期',
								prop: 'date',
								slotScope: true,
								width: 300
							},
							// {
							// 	label: '休息时间',
							// 	prop: 'time',
							// 	slotScope: true,
							// 	width: 200
							// },
							{
								label: '备注',
								prop: 'remark',
								slotScope: true,
							},
							{
								label: '话术',
								prop: 'msgId',
								slotScope: true,
							},
							{
								label: '操作',
								prop: 'action',
								slotScope: true,
								width: 200
							}
						]
					},
					{
						name: '特殊上班时间设置',
						type: 'exceptionList',
						add_obj: {
							date: [],
							priority: '',
							// time: '',
							remark: ''
						},
						tableData: [],
						column: [
							// {
							// 	label: "优先级",
							// 	prop: "index",
							// 	type: "index",
							// 	width: 80
							// }, 
							{
								label: '日期',
								prop: 'date',
								slotScope: true,
								width: 300
							},
							// {
							// 	label: '工作时间',
							// 	prop: 'time',
							// 	slotScope: true,
							// 	width: 200
							// },
							{
								label: '备注',
								prop: 'remark',
								slotScope: true,
							}, {
								label: '操作',
								prop: 'action',
								slotScope: true,
								width: 200
							}
						]
					}
				],
				workDayList: [],
				holidayList: [],
				exceptionList: [],
				loading: false

			}
		},
		methods: {
			getTableData(key) {
				return this[key]
			},
			updateData(val) {
				this.post_datas[val.type] = val.tableData
			},
			onSave() {
				this.loading = true
				let parmas = {
					brandId: this.details.brandId,
					skillGroupId: this.details.skillGroupId,
					workDayList: this.formatPostData(this.post_datas.workDayList, 'work'),
					holidayList: this.formatPostData(this.post_datas.holidayList, 'holiday'),
					exceptionList: this.formatPostData(this.post_datas.exceptionList, 'exception')
				}
				this.$api.updateSystemEffectListItem(parmas).then(res => {
					if (res.errcode == 0) {
						this.$message.success('保存成功')
						this.dialogVisible = false
						this.$emit('getList')
					}
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			onAdd() {
				this.dialogVisible = true
			},
			// 格式化保存参数
			formatPostData(data, type) {
				let result = [];
				if (data.length == 0) {
					return []
				}
				data.map((item, index) => {
					result.push({
						beginTime:this.formatPostTime(type,item) ? this.formatPostTime(type,item)[0] : '',
						endTime: this.formatPostTime(type,item) ? this.formatPostTime(type,item)[1] : '',
						brand: this.details.brandId,
						skillGroup: this.details.skillGroupId,
						workdayType: this.formatPostType(type),
						workdaySubType: this.formatPostSubType(type, item.workdaySubType),
						remark: item.remark || '',
						priority: (index + 1),
						id: item.id || '-1',
						msgId:item.msgId || ''
					})
				})
				return result
			},
			formatPostTime(type, val) {
				let result = ''
				let start='';
				let end = '';
				switch (type) {
					case 'work':
						result = val.time
						break;
					default:
						// start = this.$dayjs(val.date[0]).format('YYYY-MM-DD') + ' ' + this.$dayjs(val.time[0]).format('HH:mm')
						// end = this.$dayjs(val.date[1]).format('YYYY-MM-DD') + ' ' + this.$dayjs(val.time[1]).format('HH:mm')
						//result = [this.$dayjs(start).valueOf(),this.$dayjs(end).valueOf()]
						result = val.date;
						break;
				}
				return result
			},
			formatPostType(type) {
				let result = ''
				switch (type) {
					case 'work':
						result = 'workday'
						break
					default:
						result = 'exceptday'
				}
				return result
			},
			formatPostSubType(type, val) {
				if (type == 'holiday') {
					return '10'
				}
				if (type == 'exception') {
					return '9'
				}
				let result = [];
				if (val.length > 1) {
					val.map(item => {
						result.push(item[1])
					})
				} else {
					result = val ? val : []
				}
				return result.join(',')

			},
			// 回填
			getDetail(val) {
				val = JSON.parse(JSON.stringify(val))
				let workDayList = [];
				let holidayList = [];
				let exceptionList = [];
				if (this.isArrayHasValue(val.workDayList)) {
					val.workDayList.map(item => {
						item.workdaySubType = this.formatSubType(item.workdaySubType)
						item.time = [item.beginTime, item.endTime]
						delete item.remark
						workDayList.push(item)
					})
				}
				if (this.isArrayHasValue(val.holidayList)) {
					val.holidayList.map(item => {
						item.date = [item.beginTime, item.endTime]
						// item.time =  [item.beginTime, item.endTime]
						holidayList.push(item)
					})
				}
				if (this.isArrayHasValue(val.exceptionList)) {
					val.exceptionList.map(item => {
						item.date = [item.beginTime, item.endTime]
						// item.time = [item.beginTime, item.endTime]
						exceptionList.push(item)
					})
				}

				this.workDayList = workDayList
				this.holidayList = holidayList
				this.exceptionList = exceptionList
			},
			// 级联展示数据
			formatSubType(val) {
				val = val ? val.split(",") : []
				if (!this.isArray(val)) {
					val = val ? val.split(",") : []
				}
				let result = [];
				// val = val ? val.split(",") : []
				if (val.length > 1) {
					val.map(item => {
						result.push(['week', item])
					})
					return result
				}
				return val
			},
			isArray(something) {
				return Object.prototype.toString.call(something) === '[object Array]';
			},
			isArrayHasValue(data) {
				if (Object.prototype.toString.call(data) === '[object Array]') {
					return data.length > 0
				}
				return false
			}

		}
	}
</script>

<style lang="scss">
	.add-edit-effect {
		section {
			height: calc(100vh - 200px);
			overflow-y: auto;
		}

		h1 {
			color: #3C4353;
			font-size: 14px;
			font-weight: 700;
		}

		&__content {
			&:nth-of-type(n+2) {
				margin-top: 40px;
			}
		}
		&__desc {
			margin-top: 50px;
			font-size: 14px;
			color: #838A9D;
			ol {
				margin-top: 10px;
			}
			li {
				color: #FF504D;
				line-height: 24px;
			}
		}
	}
</style>
